<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div class="d-flex profile-box justify-content-between">
  <ngx-spinner
    type="ball-clip-rotate"
    [fullScreen]="false"
    [name]="spinnerName"
    color="rgba(0,0,0,0.5)"
    bdColor="rgba(255,255,255,0.5)"
    size="default"
  ></ngx-spinner>
  <!-- Invite to LFX -->
  <div
    *ngIf="(!hasUsername || !hasDashboardAccess) && isValidEmailDomain && employeeEmailAddress"
    class="invite-to-lfx"
  >
    <div
      class="new-employee-button"
      *ngIf="canMakeUpdates$ | async"
      (click)="!loading && inviteEmployee()"
    >
      <i class="fal fa-envelope" *ngIf="!loading"></i>
      <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
      Invite to LFX
    </div>
  </div>
  <div class="left d-flex">
    <div class="avartar-container">
      <lfx-avatar
        [name]="
          employeeDetails?.memberDisplayName || defaultEmployeeObject?.name
        "
        [imageURL]="
          employeeDetails?.userPhotoUrl || defaultEmployeeObject?.logoUrl
        "
        size="xxl"
      ></lfx-avatar>
    </div>
    <div class="align-self-center left-info">
      <!-- Name  -->
      <div class="name">
        {{
          employeeIncludesUnknownText
            ? employeeEmailAddress
            : employeeDetails?.memberDisplayName || defaultEmployeeObject?.name
        }}
      </div>
      <ng-container *ngIf="employeeDetails">
        <!-- Org Name -->
        <div class="org-name">
          <span *ngIf="!isAllOrgsRollup">{{ organization.name }}</span>
          <span
            *ngIf="isAllOrgsRollup && employeeDetails?.currentEmployer?.length"
            >{{ employeeDetails?.currentEmployer[0]?.organizationName }}</span
          >
        </div>
        <!-- Job Title -->
        <div class="job-title" *ngIf="employeeDetails?.jobTitle">
          {{ employeeDetails?.jobTitle }}
        </div>
        <!-- Stint -->
        <lfx-stint [stint]="stint"></lfx-stint>
      </ng-container>
    </div>
  </div>
  <div class="right">
    <!-- Location -->
    <div>
      <i class="fal fa-map-marker-alt"></i>
      <span class="location">{{
        employeeDetails?.country || noDataPlaceholder
      }}</span>
    </div>
    <!-- Github -->
    <div>
      <i class="fab fa-github"></i>
      <span class="right-text">
        <ng-container
          *ngIf="employeeDetails?.github; else githubPlaceholderTpl"
        >
          <a
            href="{{ formatGithubLink(employeeDetails?.github) }}"
            target="_blank"
            class="lf-link"
            >{{ employeeDetails?.github }}</a
          >
        </ng-container>
      </span>
    </div>
    <!-- Email Address -->
    <div>
      <i class="fal fa-envelope"></i>
      <span class="right-text">
        <ng-container
          *ngIf="
            isValidEmailDomain &&
              employeeEmailAddress &&
              !employeeIncludesUnknownText;
            else emailPlaceholderTpl
          "
        >
          <a [href]="emailLink" class="lf-link">{{ employeeEmailAddress }}</a>
        </ng-container>
      </span>
    </div>
  </div>
</div>

<ng-template #noDataPlaceholderTpl>
  {{ noDataPlaceholder }}
</ng-template>

<!-- GitHub Placeholder with Info Tooltip for LF Staff -->
<ng-template #githubPlaceholderTpl>
  {{ noDataPlaceholder }}
  <lfx-hover-trigger
    *ngIf="isLFStaff$ | async"
    placement="top"
    popoverClass="info-tooltip"
    [openDelay]="200"
    [closeDelay]="100">
    <i class="fal fa-info-circle text-muted ms-1"></i>
    <div slot="popover-content">
      <div class="tooltip-content">
        <strong>Why is this empty?</strong>
        <p class="mb-0 mt-1">{{ githubTooltipMessage }}</p>
      </div>
    </div>
  </lfx-hover-trigger>
</ng-template>

<!-- Email Placeholder with Info Tooltip for LF Staff -->
<ng-template #emailPlaceholderTpl>
  {{ noDataPlaceholder }}
  <lfx-hover-trigger
    *ngIf="isLFStaff$ | async"
    placement="top"
    popoverClass="info-tooltip"
    [openDelay]="200"
    [closeDelay]="100">
    <i class="fal fa-info-circle text-muted ms-1"></i>
    <div slot="popover-content">
      <div class="tooltip-content">
        <strong>Why is this empty?</strong>
        <p class="mb-0 mt-1">{{ emailTooltipMessage }}</p>
      </div>
    </div>
  </lfx-hover-trigger>
</ng-template>
